var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('acgn-statistic-detail-nor',{attrs:{"comicId":_vm.comicId,"userId":_vm.userId,"exportCode":"6005","type":2,"isShowModify":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }